import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import { MoneyTaskError } from "api/generated/model";

export function getMoneyTaskErrorMessage(
    t: TFunction,
    error: MoneyTaskError
): string {
    switch (error.type) {
        case "CurrencyNotEnabled":
            return t("CreateControl_Submit_MoneyCurrencyNotEnabledError", {
                currency: error.currency,
                task: error.task.title,
            });
        default:
            return assertNever(error.type);
    }
}
